import { render, staticRenderFns } from "./SearchEvents.vue?vue&type=template&id=5288be30"
import script from "./SearchEvents.vue?vue&type=script&lang=js"
export * from "./SearchEvents.vue?vue&type=script&lang=js"
import style0 from "./SearchEvents.vue?vue&type=style&index=0&id=5288be30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports